module.exports = __webpack_public_path__ + "static/media/8OLA21.64dfefd6.jpg";